import React from 'react';
import { useIntl } from 'react-intl';
import Text from '../../../../global/text/text';
import { EyeIcon } from '../../../../global/icons/icons';
import { PASSPORT_PREVIEW_TEXT } from '../../../../../constants/common-labels.constants';

interface IProps {
    connectionLabel: string;
    onClickPreview: () => void;
    disabled?: boolean;
}

const PassportDisplayHeader: React.FC<IProps> = ({ connectionLabel, disabled, onClickPreview }) => {
    const intl = useIntl();
    const previewButtonClass = `configure-passport-header__preview-text${disabled ? ' disabled' : ''}`;
    return (
        <div className='oe-popup-layout__header configure-passport-header' >
            <div className='configure-passport-header__item'>
                <Text className='configure-passport-header__connection-label' message={connectionLabel} />
            </div>
            <div className={previewButtonClass} onClick={onClickPreview}>
                <EyeIcon />
                <Text className='send-preview-text' message={intl.formatMessage(PASSPORT_PREVIEW_TEXT)} />
            </div>
        </div>
    );
};

export { PassportDisplayHeader };
